(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);
        const footerMenus = Array.from(document.querySelectorAll('footer-menu'));
        const isLastFooterMenu = footerMenus.length > 0 && footerMenus[footerMenus.length - 1] === this;

        let shouldOpen = isLargeScreen || isConfirmNewsletter;

        // 移动端默认展开最后一个 footer-menu
        if (!isLargeScreen && isLastFooterMenu) {
          shouldOpen = true;
        }

        this.disclosure.open = shouldOpen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('account-popover')) {
    class AccountPopover extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.downobox__trigger');
        this.panel = this.querySelector('.downobox');
        if (!this.trigger || !this.panel || this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'touch') return;
          this.dismissed = false;
          this.openedByEntry = this.openedByEntry || !this.isOpen;
          this.setOpen(true);
        }, options);
        this.addEventListener('pointerleave', () => {
          if (!this.contains(document.activeElement)) this.setOpen(false);
          this.dismissed = false;
        }, options);
        this.addEventListener('focusin', () => {
          if (this.dismissed) return;
          this.openedByEntry = this.openedByEntry || !this.isOpen;
          this.setOpen(true);
        }, options);
        this.addEventListener('focusout', (event) => {
          if (this.contains(event.relatedTarget)) return;
          this.dismissed = false;
          this.openedByEntry = false;
          this.setOpen(false);
        }, options);
        this.trigger.addEventListener('click', () => {
          if (this.openedByEntry) {
            this.openedByEntry = false;
            this.setOpen(true);
          } else {
            this.dismissed = this.isOpen;
            this.setOpen(!this.isOpen);
          }
        }, options);
        document.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !this.isOpen) return;
          event.preventDefault();
          this.dismissed = true;
          this.openedByEntry = false;
          const restoreFocus = this.contains(document.activeElement);
          this.setOpen(false);
          if (restoreFocus) this.trigger.focus({ preventScroll: true });
        }, options);
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.setOpen(false);
        }, options);
        window.addEventListener('pagehide', () => this.setOpen(false), options);
        this.setOpen(false);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.setOpen(false);
      }

      setOpen(open) {
        this.isOpen = open;
        if (!open) this.openedByEntry = false;
        this.trigger?.setAttribute('aria-expanded', String(open));
        this.panel?.setAttribute('aria-hidden', String(!open));
      }
    }
    customElements.define('account-popover', AccountPopover);
  }
  $(function(){
    $('header').on('click','.icon-support',function(){
      window.vanchat_widget.open();
    });
  });
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manual-product-feature-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('manual-product-feature-cards')) {
    customElements.define('manual-product-feature-cards', class ManualProductFeatureCards extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-product-feature-track]');
        this.previousButton = this.querySelector('[data-product-feature-previous]');
        this.nextButton = this.querySelector('[data-product-feature-next]');

        if (!this.track || !this.previousButton || !this.nextButton) return;

        this.previousButton.addEventListener('click', () => this.scroll(-1));
        this.nextButton.addEventListener('click', () => this.scroll(1));
        this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
        window.addEventListener('resize', () => this.updateButtons());
        this.updateButtons();
      }

      scroll(direction) {
        const item = this.track.querySelector('.product-feature-cards__item');
        if (!item) return;

        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (item.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }

      updateButtons() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.previousButton.disabled = this.track.scrollLeft <= 1;
        this.nextButton.disabled = this.track.scrollLeft >= maximum - 1 || maximum <= 1;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-feature-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-feature-cards')) {
    customElements.define('product-feature-cards', class ProductFeatureCards extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-product-feature-track]');
        this.previousButton = this.querySelector('[data-product-feature-previous]');
        this.nextButton = this.querySelector('[data-product-feature-next]');

        if (!this.track || !this.previousButton || !this.nextButton) return;

        this.previousButton.addEventListener('click', () => this.scroll(-1));
        this.nextButton.addEventListener('click', () => this.scroll(1));
        this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
        window.addEventListener('resize', () => this.updateButtons());
        this.updateButtons();
      }

      scroll(direction) {
        const item = this.track.querySelector('.product-feature-cards__item');
        if (!item) return;

        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (item.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }

      updateButtons() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.previousButton.disabled = this.track.scrollLeft <= 1;
        this.nextButton.disabled = this.track.scrollLeft >= maximum - 1 || maximum <= 1;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wheel-of-fortune"]) return;
  try {
    
  (($) => {
      
   var wheel = $('#wheel');
   var arrow = $('#arrow');
   var info = $("#info");
   
   var numItems = 8;
   var arc = 360 / numItems;
   
   TweenLite.set(wheel, { rotation: 360 });
   
   var prizes = [
     "Shirt",
     "Free Bucket",
     "Night Out #1",
     "Je Vangt Bot",
     "BioScoop Tickets",
     "Night Out #2",
     "Free Spin",
      "HMH Tickets"
   ];
   
   arrow.on('click', () => {
     
      // var random = Math.floor(Math.random() * 8000) + 6000;
      var random = Math.floor(Math.random() * 800) + 600;
      var tl = new TimelineMax();
      tl 
         .to(wheel, 7, { rotation: "+=" + random, ease: Back.easeOut.config(1) })

      TweenLite.to(tl, 4, {timeScale:0, ease: Power1.easeOut, delay: 3 })
   })
   
   TweenLite.ticker.addEventListener("tick", update);
   
   function update() {
     
     var rotation = wheel[0]._gsTransform.rotation;     
     var angle = rotation - 360 * Math.floor(rotation / 360);     
     var index = Math.floor((360 - angle) / arc) % prizes.length;    
     var prize = prizes[index];
     
     info.html("Current Prize = " + prize);
   }
      
})(jQuery)

  } catch(e) { console.error(e); }
})();
})();
